export const SET_BANNER = 'SET_BANNER';
export const RESET_BANNER = 'RESET_BANNER';
